import React from "react";
import MyInput from "components/controls/MyInput";
import DropdownList from "components/controls/DropdownList";
import _validator from "modules/validator";
import _StudentService from "../../modules/StudentService";
import _notification from "modules/notification";
import { useState, useEffect } from "react";
import { Button, Tag } from "antd";
import add_new from "assets/img/add_new.png";
import remove from "assets/img/remove.png";
import { Tooltip } from "antd";
// Phase C.5 (Candidate System UI Language Migration): moved off hardcoded English+Marathi literals
// onto the centralized Text/dictionary.js architecture — see qualificationInfo.js.
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';
import {
  Qualification_DEGREE_ID,
  Qualification_PG_ID,
  Qualification_Diploma_ID,
  LAW_OFFICER_BANKING_OFFICER_GR2_ID,
  ASSISTANT_LAW_OFFICER_CLERK_ID,
  CA_BANKING_OFFICER_GR1_ID,
  IT_OFFICERS_BANKING_OFFICER_GR1_ID,
  IT_OFFICERS_BANKING_OFFICER_GR2_ID,
  STENOGRAPHER_CLERK_ID,
  ACCOUNTANT_BANKING_OFFICER_GR2_ID,
  CLERK_ID,
} from "../../constants/constants.js";
import { BACK_YEARS_FOR_PASSING_YEAR } from "constants/constants.js";

function tr(key) {
  return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

const classList = [
  { Id: "Pass", Name: "Pass" },
  { Id: "Second", Name: "Second" },
  { Id: "First", Name: "First" },
  { Id: "Distinction", Name: "Distinction" },
];

const QualificationRow_new = (props) => {
  const [row, setRow] = useState([]);

  const [candidateData, setCandidateData] = useState({});
  const [specializationData, setSpecializationData] = useState([]);
  const [otherText, setOtherText] = useState(false);
  const [otherEducationText, setOtherEducationText] = useState(false);
  const [otherEducationID, setOtherEducationID] = useState(false);
  const [otherID, setOtherID] = useState(0);
  const [updatedCandidatePersonalInfo, setCandidatePersonalInfo] = useState({});

  const generateYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();

    for (
      let year = currentYear, id = 1;
      year >= currentYear - BACK_YEARS_FOR_PASSING_YEAR;
      year--, id++
    ) {
      years.push({ Id: year.toString(), Name: year.toString() });
    }

    return years;
  };

  const passingYears = generateYears();

  useEffect(() => {
    if (
      props.candidatePersonalInfo &&
      updatedCandidatePersonalInfo &&
      props.candidatePersonalInfo.Applied_PostId !==
      updatedCandidatePersonalInfo.Applied_PostId
    ) {
      setCandidatePersonalInfo(props.candidatePersonalInfo);
    }
  }, [props.candidatePersonalInfo]);

  useEffect(() => {
    if (props.row && props.candidateData) {
      let tempData = props.candidateData.find(
        (item) =>
          (item.hasOwnProperty("newRowID") && item.newRowID == props.row.Id) ||
          item.Qualification_Id == props.row.Id
      );

      let specializationDataTemp = props.data.filter(
        (item) => item.ParentId == props.row.Id
      );

      var jsonData = [];

      let result = specializationDataTemp.reduce((acc, curr) => {
        acc.push({
          Id: curr.Id,
          Name: curr.Qualification_Name,
        });
        return acc;
      }, []);

      setRow(props.row);
      setCandidateData(tempData ?? []);

      setSpecializationData(result);

      //validation according to posts


      // const { Applied_PostId } = props.candidatePersonalInfo;

      // let specialization = result;

      // if (Applied_PostId === 1024 || Applied_PostId === 1025) {
      //   specialization = result.filter(
      //     (item) => item.Name === "LLB" && item.Id === 26
      //   );
      // } else if (Applied_PostId === 1026) {
      //   specialization = result.filter(
      //     (item) => item.Name === "CA" && item.Id === 11
      //   );
      // } else if (Applied_PostId === 1027 || Applied_PostId === 1028) {
      //   specialization = result.filter(
      //     (item) =>
      //       (item.Name === "B.E (Computer)" && item.Id === 48) ||
      //       (item.Name === "B.E (IT)" && item.Id === 49) ||
      //       (item.Name === "B.E (E&TC)" && item.Id === 50) ||
      //       (item.Name === "B.Tech (Computer)" && item.Id === 51) ||
      //       (item.Name === "B.Tech (IT)" && item.Id === 52) ||
      //       (item.Name === "B.Tech (E&TC)" && item.Id === 53)
      //   );
      // } else if (Applied_PostId === 1029) {
      //   specialization = result.filter(
      //     (item) => item.Name === "Stenography" && item.Id === 47
      //   );
      // } else if (Applied_PostId === 1030) {
      //   specialization = result.filter(
      //     (item) => item.Name === "M.Com." && item.Id === 32
      //   );
      // } else if (
      //   Applied_PostId === 1031 ||
      //   Applied_PostId === 1032 ||
      //   Applied_PostId === 1033
      // ) {
      //   setSpecializationData(specialization);
      //   return;
      // } else {
      //   specialization = result; // Fallback
      // }

      // setSpecializationData(
      //   specialization.length > 0 ? specialization : result
      // );


      const { Applied_PostId } = props.candidatePersonalInfo;

      let specialization = result;

      switch (Applied_PostId) {
        case 1024:
        case 1025:
          specialization = result.filter(
            (item) => item.Name === "LLB" && item.Id === 26
          );
          break;
        case 1026:
          specialization = result.filter(
            (item) => item.Name === "CA" && item.Id === 11
          );
          break;
        case 1027:
        case 1028:
          specialization = result.filter(
            (item) =>
              (item.Name === "B.E (Computer)" && item.Id === 48) ||
              (item.Name === "B.E (IT)" && item.Id === 49) ||
              (item.Name === "B.E (E&TC)" && item.Id === 50) ||
              (item.Name === "B.Tech (Computer)" && item.Id === 51) ||
              (item.Name === "B.Tech (IT)" && item.Id === 52) ||
              (item.Name === "B.Tech (E&TC)" && item.Id === 53)
          );
          break;
        case 1029:
          specialization = result.filter(
            (item) =>
              (item.Name === "Stenography" && item.Id === 47)
          );
          break;
        case 1030:
          specialization = result.filter(
            (item) =>
              (item.Name === "M.Com." && item.Id === 32)
          );
          break;
        case 1031:
        case 1032:
        case 1033:
          setSpecializationData(specialization);
          return;
        default:
          specialization = result; // Fallback: return all if no match
      }

      // if (props.row.Id === 5 && Applied_PostId !== 1029) {
      //   specialization = [];
      //   result = [];
      // }

      setSpecializationData(
        specialization.length > 0 ? specialization : result
      );


      if (
        props.row.Qualification_Name == "Other" ||
        props.row.Qualification_Name.toLowerCase().includes(
          "MH-CIT".toLowerCase()
        )
      ) {
        setOtherText(true);
      } else {
        if ((tempData ? tempData.University_Name : "") == "Other") {
          setOtherText(true);
        }

        if ((tempData ? tempData.University_Id : 0) == 0) {
          setOtherText(true);
        }

        if (
          (tempData ? tempData.University_Id : 0) == 0 &&
          (tempData ? tempData.Other_Information : 0) == ""
        ) {
          setOtherText(false);
        }
      }

      if (
        (tempData
          ? tempData.Specilisation && tempData.Specilisation.trim()
          : "") == "Other"
      ) {
        setOtherEducationText(true);
      }
    }
  }, []);

  let onTextChange = (event) => {
    if (
      event.target.name == "Passed_Year" &&
      !_validator.isDigit(event.target.value)
    )
      return;

    if (event.target.name == "Passed_Year" && event.target.value.length > 4)
      return;

    if (
      event.target.name == "Percentage_Grade" &&
      event.target.value.length > 5
    )
      return;

    // if ((updatedCandidatePersonalInfo && updatedCandidatePersonalInfo.Applied_PostId === JUNIOR_MANAGEMENT_ID) ||
    // (updatedCandidatePersonalInfo && updatedCandidatePersonalInfo.Applied_PostId === JUNIOR_CLERK_ID)) {
    //     if (event.target.name == 'Percentage_Grade' && !_validator.isDigitPercent(event.target.value))
    //         return
    // }

    //console.log({ [event.target.name]: event.target.value, ['newRowID']: row.Id });
    setCandidateData({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
    props.onCandidateQualification({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
  };

  let onPassedYearChange = (event) => {
    // setCandidateData({ ...candidateData, Passed_Year: event.target.value });
    // console.log("event++", event.target)
    // console.log("event", event.target.name)
    // console.log("eventValue", event.target.value)
    // console.log("candidateData.Passed_Year", candidateData.Passed_Year)

    if (
      event.target.name == "Passed_Year" &&
      !_validator.isDigit(event.target.value)
    )
      return;

    if (event.target.name == "Passed_Year" && event.target.value.length > 4)
      return;

    // if (event.target.name == 'Passed_Year' && event.target.value.length > 4)
    //     return;

    setCandidateData({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
    props.onCandidateQualification({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
  };

  let onOtherTextChange = (event) => {
    //console.log("onOtherTextChange: ", { [event.target.name]: event.target.value, ['newRowID']: row.Id });

    let value = event.target.value.trim();

    const allowedQualifications = [
      "degree",
      "s.s.c (10th)",
      "h.s.c (12th)",
      "post graduation",
      "diploma details",
      "ms-cit / doeacc / other equivalent qualification",
      "other qualification"
    ];

    if (
      value.length > 250 &&
      allowedQualifications.includes(row.Qualification_Name?.toLowerCase())
    ) {
      return;
    }

    let otherText =
      event.target.name == "Other_Information" && !event.target.value
        ? "deleted"
        : event.target.value;
    let obj =
      otherText == "deleted"
        ? { Passed_Year: "", Percentage_Grade: "", Class: "" }
        : {};
    let candidateDataObj = {
      ...candidateData,
      [event.target.name]: otherText,
      ["newRowID"]: row.Id,
      ["University_Id"]: otherID,
    };
    setCandidateData(candidateDataObj);
    props.onCandidateQualification({
      ...candidateData,
      [event.target.name]: otherText,
      ["newRowID"]: row.Id,
      ["University_Id"]: otherID,
      ...obj,
    });

    if (event.target.value.trim() == "" && row.Qualification_Name != "Other") {
      //console.log("Other Set: ");
      setOtherText(false);
      delete candidateData.Id;
      setCandidateData({
        ...candidateDataObj,
        University_Id: null,
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
        University_Name: "",
      });
    }

    if (event.target.value.trim() == "" && row.Qualification_Name == "Other") {
      setCandidateData({
        ...candidateData,
        [event.target.name]: "",
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
    }

    if (
      event.target.value.trim() == "" &&
      row.Qualification_Name == "MS-CIT/DOEACC (Computer Certificate)"
    ) {
      setOtherText(false);
      delete candidateData.Id;
      setCandidateData({
        ...candidateData,
        University_Id: null,
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
    }

    if (
      event.target.value.trim() == "" &&
      row.Qualification_Name == "MS-CIT/DOEACC (Computer Certificate)"
    ) {
      setCandidateData({
        ...candidateData,
        [event.target.name]: "",
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
    }


  };

  // let onOtherSpecializationTextChange = (event) => {
  //   //console.log("onOtherTextChange: ", { [event.target.name]: event.target.value, ['newRowID']: row.Id });

  //   let value = event.target.value.trim();

  //   if (value.length > 30 && row.Qualification_Name.toLowerCase() === "post graduation") {
  //     return;
  //   }

  //   if (value.length > 30 && row.Qualification_Name.toLowerCase() === "degree") {
  //     return;
  //   }

  //   if (value.length > 30 && row.Qualification_Name.toLowerCase() === "diploma details") {
  //     return;
  //   }

  //   //Post Graduation
  //   let otherText =
  //     event.target.name == "other_specilisation" && !event.target.value
  //       ? "deleted"
  //       : event.target.value;
  //   let obj =
  //     otherText == "deleted"
  //       ? { Passed_Year: "", Percentage_Grade: "", Class: "" }
  //       : {};
  //   setCandidateData({
  //     ...candidateData,
  //     [event.target.name]: otherText,
  //     ["newRowID"]: row.Id,
  //     Specilisation_Id: otherEducationID,

  //   });
  //   props.onCandidateQualification({
  //     ...candidateData,
  //     [event.target.name]: otherText,
  //     ["newRowID"]: row.Id,
  //     Specilisation_Id: otherEducationID,
  //     ...obj,
  //   });

  //   if (event.target.value.trim() == "" && row.other_specilisation != "Other") {
  //     //console.log("Other Set: ");
  //     setOtherEducationText(false);
  //     delete candidateData.Id;
  //     setCandidateData({
  //       ...candidateData,
  //       Specilisation_Id: 0,
  //       University_Id: 0,
  //       Passed_Year: "",
  //       Percentage_Grade: "",
  //       Class: "",
  //       Specilisation: "",
  //     });
  //   }

  //   if (event.target.value.trim() == "" && row.other_specilisation == "Other") {
  //     setCandidateData({
  //       ...candidateData,
  //       [event.target.name]: "",
  //       Passed_Year: "",
  //       Percentage_Grade: "",
  //       Class: "",
  //     });
  //   }
  // };

  let onOtherSpecializationTextChange = (event) => {
    //console.log("onOtherTextChange: ", { [event.target.name]: event.target.value, ['newRowID']: row.Id });
    // debugger
    let value = event.target.value.trim();

    if (value.length > 30 && row.Qualification_Name.toLowerCase() === "post graduation") {
      return;
    }

    if (value.length > 30 && row.Qualification_Name.toLowerCase() === "degree") {
      return;
    }

    if (value.length > 30 && row.Qualification_Name.toLowerCase() === "diploma details") {
      return;
    }


    //Post Graduation
    let otherText =
      event.target.name == "other_specilisation" && !event.target.value
        ? "deleted"
        : event.target.value;
    let obj =
      otherText == "deleted"
        ? { Passed_Year: "", Percentage_Grade: "", Class: "" }
        : {};

    if (row.Qualification_Name == "Other Qualification") {

      let CandidateTemp = {
        ...candidateData,
        [event.target.name]: otherText,
        ["newRowID"]: row.Id,
        Specilisation_Id: otherEducationID,
        Specilisation: "Other",

      }
      setCandidateData(CandidateTemp);

      props.onCandidateQualification({
        ...candidateData,
        [event.target.name]: otherText,
        ["newRowID"]: row.Id,
        Specilisation_Id: otherEducationID,
        Specilisation: "Other",
        ...obj,
      });

    } else {
      let CandidateTemp = {
        ...candidateData,
        [event.target.name]: otherText,
        ["newRowID"]: row.Id,
        Specilisation_Id: otherEducationID,
      }

      setCandidateData(CandidateTemp);
      props.onCandidateQualification({
        ...candidateData,
        [event.target.name]: otherText,
        ["newRowID"]: row.Id,
        Specilisation_Id: otherEducationID,
        ...obj,
      });
    }

    if (event.target.value.trim() == "" && row.other_specilisation != "Other") {
      //console.log("Other Set: ");
      setOtherEducationText(false);
      delete candidateData.Id;
      setCandidateData({
        ...candidateData,
        Specilisation_Id: 0,
        University_Id: 0,
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
        Specilisation: "",
        [event.target.name]: otherText,
      });
    }

    if (event.target.value.trim() == "" && row.other_specilisation == "Other") {
      setCandidateData({
        ...candidateData,
        [event.target.name]: "",
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
    }
  };


  let onCategoryChange = (event) => {
    //console.log({ [event.target.name]: event.target.value, ['newRowID']: row.Id });
    setCandidateData({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
    props.onCandidateQualification({
      ...candidateData,
      [event.target.name]: event.target.value,
      ["newRowID"]: row.Id,
    });
  };

  let onEducationChange = (event) => {
    let tempData = specializationData.find(
      (item) => item.Id == event.target.value
    );

    if (tempData && tempData.Name.trim() == "Other") {
      setOtherEducationText(true);
      setOtherEducationID(tempData.Id);
      setCandidateData({
        ...candidateData,
        other_specilisation: "",
        Specilisation_Id: tempData.Id,
        Specilisation: tempData.Name,
        Other_Information: "",
        ["newRowID"]: row.Id,
        University_Id: 0,
        University_Name: "",
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
      // if any other related issue found check below line
      props.onCandidateQualification({
        ...candidateData,
        other_specilisation: "",
        Specilisation: tempData.Name,
        Specilisation_Id: tempData.Id,
        Other_Information: "",
        ["newRowID"]: row.Id,
        University_Id: 0,
        University_Name: "",
        Passed_Year: "",
        Percentage_Grade: "",
        Class: "",
      });
    } else {
      //console.log({ [event.target.name]: event.target.value, ['newRowID']: row.Id });
      let clearData = tempData ? {} : { Specilisation_Id: 0 };
      setCandidateData({
        ...candidateData,
        ...clearData,
        Specilisation: tempData ? tempData.Name : "deleted",
        [event.target.name]: event.target.value,
        ["newRowID"]: row.Id,
        other_specilisation: ""
      });
      props.onCandidateQualification({
        ...candidateData,
        ...clearData,
        Specilisation: tempData ? tempData.Name : "deleted",
        [event.target.name]: event.target.value,
        ["newRowID"]: row.Id,
        other_specilisation: ""
      });
      if (tempData && tempData.Name === "deleted") {
        setCandidateData({
          ...candidateData,
          Passed_Year: "",
          Specilisation_Id: 0,
          other_specilisation: "",
          Percentage_Grade: "",
          Class: "",
          University_Name: "",
          University_Id: 0,
          ["newRowID"]: row.Id,
        });
      }
    }

    // setCandidateData({ ...candidateData, [event.target.name]: event.target.value, ['newRowID']: row.Id });
    // props.onCandidateQualification({ ...candidateData, [event.target.name]: event.target.value, ['newRowID']: row.Id });
  };

  let onUniversityChange = (event) => {
    let tempData = props.allUniversities.find(
      (item) => item.Id == event.target.value
    );

    if (tempData && tempData.Name == "Other") {
      setOtherText(true);
      setOtherID(tempData.Id);
      setCandidateData({
        ...candidateData,
        // other_specilisation: "",
        Specilisation: "",
        University_Name: "",
        //Other_Information: "", // if any other related issue found check this line
        ["newRowID"]: row.Id,

        Passed_Year: "", // if any other related issue found check this line
        // Specilisation_Id: 0, // if any other related issue found check this line
        Percentage_Grade: "", // if any other related issue found check this line
        Class: "", // if any other related issue found check this line
        University_Id: 0, // if any other related issue found check this line
      });

      // if any other related issue found check below line
      props.onCandidateQualification({
        ...candidateData,
        other_specilisation: "",
        Specilisation: "",
        University_Name: "",
        Other_Information: "",
        ["newRowID"]: row.Id,

        Passed_Year: "",
        // Specilisation_Id: 0,
        Percentage_Grade: "",
        Class: "",
        University_Id: 0,
      });
    } else {
      //console.log({ [event.target.name]: event.target.value, ['newRowID']: row.Id });
      let clearData = tempData ? {} : { Specilisation_Id: 0 };
      setCandidateData({
        ...candidateData,
        ...clearData,
        University_Name: tempData ? tempData.Name : "deleted",
        [event.target.name]: event.target.value,
        ["newRowID"]: row.Id,
        other_specilisation: "",
        Specilisation: "",
        // Specilisation_Id: 0,
        Other_Information: "",  // if any other related issue found check this line
      });
      props.onCandidateQualification({
        ...candidateData,
        ...clearData,
        University_Name: tempData ? tempData.Name : "deleted",
        [event.target.name]: event.target.value,
        ["newRowID"]: row.Id,
        other_specilisation: "",
        Specilisation: "",
        Specilisation_Id: 0,
        Other_Information: "", // if any other related issue found check this line
      });
      if (tempData && tempData.Name === "deleted") {
        setCandidateData({
          ...candidateData,
          Passed_Year: "",
          Specilisation_Id: 0,
          Percentage_Grade: "",
          Class: "",
          University_Name: "",
          University_Id: 0,
          ["newRowID"]: row.Id,
        });
      }
    }
  };

  const handleBlur = (e) => {
    if (e.target.value == "") {
      onOtherTextChange(e);
    }
  };

  const handleOtherSpecializationBlur = (e) => {
    if (e.target.value == "") {
      onOtherSpecializationTextChange(e);
    }
  };

  return (
    <>
      {/* Phase C.7.4D-R6.4A (unified-matrix correction): R6.4 pulled the qualification name out of the
          table's column structure into a standalone heading line above every row, which — combined with
          R6.4's other change of un-hiding each row's own field labels — turned the single-header table
          into a sequence of repeated mini-forms (every row re-showed "Board/University Name", "Passing
          Year", etc., and every hardcoded `isRequired` field-level asterisk became visible on every row).
          Root cause of both defects was the `.hideLabel-desktop` flip in themes.scss; see the comment
          there. Fix: the qualification name goes back to being column 1 of the SAME row grid the other
          fields use, so the whole row (name + fields) reads as one aligned matrix row under the ONE
          header row rendered by QualificationTableHeader_new.jsx above. Kept from R6.4: the name is
          still plain, bold text (not the old `.custom-input` boxed/disabled look), and the mandatory
          asterisk still reflects the same `props.row.IsMandetory` business flag as before. */}
      <div className="row flex-sm-row  pt-3 qualif-row-fields">
        <div className="col-sm-2 align-self-center qualif-name-cell">
          {props.row.Qualification_Name}
          {props.row.IsMandetory && (
            <span className="pl-1 color-red h4 font-bold">*</span>
          )}
        </div>
        {/* <div className="col-sm-2 align-self-center">
          {specializationData.length != 0 ? (
            <>
              {otherEducationText || candidateData.Specilisation === "Other" ? (
                <MyInput
                  type="text"
                  value={candidateData ? candidateData.other_specilisation : ""}
                  name="other_specilisation"
                  onChange={onOtherSpecializationTextChange}
                  onBlur={handleOtherSpecializationBlur}
                  heading={
                    <div className="displayInGrid">
                      <Text k="qualificationInfo.specializationLabel" />
                    </div>
                  }
                  //heading="Precent Grade"
                  //style={{ width: '60px' }}
                  wrapClass="wrap hideLabel-desktop"
                  isRequired={true}
                />
              ) : (
                <Tooltip
                  title={
                    candidateData.Specilisation_Id || candidateData.Specilisation === "Other"
                      ? candidateData.Specilisation
                      : tr('qualificationInfo.selectAnOptionPlaceholder')
                  }
                  placement="top"
                >
                  <div>
                    <DropdownList
                      value={
                        candidateData.Specilisation_Id
                          ? candidateData.Specilisation_Id
                          : 0
                      }
                      isDisabled={false}
                      name="Specilisation_Id"
                      onChange={onEducationChange}
                      heading={
                        <div className="displayInGrid">
                          <Text k="qualificationInfo.specializationLabel" />
                        </div>
                      }
                      //placeholder="Select Category"
                      //heading={"Category"}
                      className="w-100"
                      wrapClass="wrap hideLabel-desktop"
                      isRequired={false}
                      //options={[{ Id: "Id", Name: "Test" }]}
                      options={specializationData}
                    //errorState={this.state.programmingLanguageState}
                    //errorMessage={this.state.programmingLanguageError}
                    />
                  </div>
                </Tooltip>
              )}
            </>
          ) : (
            <></>
          )}
        </div> */}

        <div className="col-sm-2 align-self-center">
          {specializationData.length != 0 ? (
            <>
              {otherEducationText || candidateData.Specilisation === "Other" ? (
                <MyInput
                  type="text"
                  value={candidateData ? candidateData.other_specilisation : ""}
                  name="other_specilisation"
                  onChange={onOtherSpecializationTextChange}
                  onBlur={handleOtherSpecializationBlur}
                  heading={
                    <div className="displayInGrid">
                      <Text k="qualificationInfo.specializationLabel" />
                    </div>
                  }
                  wrapClass="wrap hideLabel-desktop"
                  isRequired={true}
                />
              ) : (
                <Tooltip
                  title={
                    candidateData.Specilisation_Id || candidateData.Specilisation === "Other"
                      ? candidateData.Specilisation
                      : tr('qualificationInfo.selectAnOptionPlaceholder')
                  }
                  placement="top"
                >
                  <div>
                    <DropdownList
                      value={candidateData.Specilisation_Id ? candidateData.Specilisation_Id : 0}
                      isDisabled={false}
                      name="Specilisation_Id"
                      onChange={onEducationChange}
                      heading={
                        <div className="displayInGrid">
                          <Text k="qualificationInfo.specializationLabel" />
                        </div>
                      }
                      className="w-100"
                      wrapClass="wrap hideLabel-desktop"
                      isRequired={false}
                      options={specializationData}
                    />
                  </div>
                </Tooltip>
              )}
            </>
          ) : (
            props.row.Qualification_Name == "Other Qualification" && (
              <MyInput
                type="text"
                value={candidateData && candidateData.other_specilisation !== "deleted" ? candidateData.other_specilisation : ""}
                name="other_specilisation"
                onChange={onOtherSpecializationTextChange}
                onBlur={handleOtherSpecializationBlur}
                heading={
                  <div className="displayInGrid">
                    <Text k="qualificationInfo.specializationLabel" />
                  </div>
                }
                wrapClass="wrap hideLabel-desktop"
                isRequired={true}
              />
            )
          )}
        </div>

        {otherText || props.row.Id == 6 || props.row.Qualification_Name == "Other Qualification" || candidateData.University_Name === "Other" ? (
          <div className="col-sm-3 align-self-center">
            <MyInput
              type="text"
              value={
                candidateData
                  ? candidateData.Other_Information === "deleted"
                    ? ""
                    : candidateData.Other_Information
                  : ""
              }
              name="Other_Information"
              onChange={onOtherTextChange}
              onBlur={handleBlur}
              heading={
                <div className="displayInGrid">
                  <Text k="qualificationInfo.boardUniversityInstituteLabel" />
                </div>
              }
              //heading="Precent Grade"
              //style={{ width: '60px' }}
              wrapClass="wrap hideLabel-desktop"
              isRequired={true}
            />
          </div>
        ) : (
          <div className="col-sm-3 align-self-center">
            {props.allUniversities.length != 0 ? (
              <DropdownList
                //value={candidateData ? candidateData.University_Id != 0 ? candidateData.University_Id : 0 : 0}
                value={candidateData ? candidateData.University_Id : 0}
                name="University_Id"
                onChange={onUniversityChange}
                className="w-100"
                wrapClass="wrap hideLabel-desktop"
                isRequired={false}
                heading={
                  <div className="displayInGrid">
                    <Text k="qualificationInfo.boardUniversityInstituteLabel" />
                  </div>
                }
                //options={[{ Id: "Id", Name: "Test" }]}
                // options={
                //   props.row.Id == 1 || props.row.Id == 2
                //     ? props.allUniversities.filter((item) => item.IsBoard)
                //     : props.allUniversities.filter((item) => !item.IsBoard)
                // }

                options={
                  props.row.Id === 1 || props.row.Id === 2
                    ? props.allUniversities.filter((item) => item.IsBoard)
                    : props.row.Id === 5
                      ? props.allUniversities.filter((item) => item.IsDiploma)
                      : props.allUniversities.filter((item) => !item.IsBoard && !item.IsDiploma)
                }
              //errorState={this.state.programmingLanguageState}
              //errorMessage={this.state.programmingLanguageError}
              />
            ) : (
              <></>
            )}
          </div>
        )}

        <Tooltip
          title={
            candidateData.Passed_Year
              ? candidateData.Passed_Year
              : tr('qualificationInfo.selectPassingYearPlaceholder')
          }
          placement="top"
        >
          <div className="align-self-center passingYearDdlAlign col-sm-2">
            {/* <MyInput
                        type="text"
                        value={candidateData ? (candidateData.Passed_Year == undefined ? "" : (candidateData.University_Name == 'deleted' ? "" : candidateData.Passed_Year)) : ""}
                        name="Passed_Year"
                        onChange={onTextChange}
                        //heading="Year"
                        style={{ width: '60px', borderColor: (candidateData ? (_validator.isPassingYearValid(candidateData.Passed_Year) ? "red" : '') : "") }}
                        wrapClass="wrap"
                        isRequired={true}
                    /> */}

            <DropdownList
              value={
                candidateData
                  ? candidateData.Passed_Year == undefined
                    ? ""
                    : candidateData.University_Name == "deleted"
                      ? ""
                      : candidateData.Passed_Year
                  : ""
              }
              options={passingYears}
              isDisabled={false}
              name="Passed_Year"
              onChange={onPassedYearChange}
              placeholder={tr('qualificationInfo.selectPassingYearPlaceholder')}
              heading={
                <div className="displayInGrid">
                  <Text k="qualificationInfo.passingYearLabel" />
                </div>
              }
              className="w-100"
              wrapClass="wrap hideLabel-desktop"
              isRequired={false}
            />
          </div>
        </Tooltip>

        <div className="col-sm-1 align-self-center">
          {/* Phase C.7.4D-R6.3 (§5) then C.7.4D-R6.4/R6.4A: the combined "Grade/Percent" column is one
              free-text field in the data model (Percentage_Grade) — unchanged. The always-visible
              caption under the field (not only a hover tooltip) keeps the field's meaning clear without
              hovering; the tooltip stays as a secondary aid. Column width restored to col-sm-1 (R6.4A) —
              matches the single shared header's own column width, so the matrix stays aligned. */}
          <Tooltip title={tr('qualificationInfo.gradePercentHelpText')} placement="top">
            <div>
              <MyInput
                type="text"
                value={
                  candidateData
                    ? candidateData.Percentage_Grade == undefined
                      ? ""
                      : candidateData.University_Name == "deleted"
                        ? ""
                        : candidateData.Percentage_Grade
                    : ""
                }
                name="Percentage_Grade"
                onChange={onTextChange}
                heading={
                  <div className="displayInGrid">
                    <Text k="qualificationInfo.gradePercentLabel" />
                  </div>
                }
                style={{ width: "60px" }}
                wrapClass="wrap hideLabel-desktop"
                isRequired={true}
              />
              <div className="qualif-field-caption">{tr('qualificationInfo.gradePercentShortHint')}</div>
            </div>
          </Tooltip>
        </div>
        <div className="col-sm-2 align-self-center">
          {/* Phase C.7.4D-R6.4A (§8): Add/Remove is repositioned back inside the Class column — the
              row's last/right-most column — instead of a standalone line above the row, so it "belongs"
              to the row without adding a 7th column to the shared header or breaking matrix alignment.
              Still rendered as always-visible icon+text (R6.4's improvement over R6.3's hover-only
              icon), just stacked under the Class dropdown instead of beside it. Same
              props.addNewRow/removeRow handlers and Id-based checks as before — no logic change. */}
          <div className="mobile-col">
            <DropdownList
              value={
                candidateData
                  ? candidateData.University_Name == "deleted"
                    ? ""
                    : candidateData.Class
                  : ""
              }
              name="Class"
              onChange={onCategoryChange}
              heading={
                <div className="displayInGrid">
                  <Text k="qualificationInfo.classLabel" />
                </div>
              }
              placeholder=""
              className="w-100"
              wrapClass="hideLabel-desktop"
              isRequired={false}
              options={classList}
            />
            {[Qualification_DEGREE_ID, 4, 7].includes(props.row.Id) && !(props.row.Id > 10000) && (
              <div
                className="addNew-row qualif-row-action qualif-row-action--add"
                data-name={"Add " + props.row.Qualification_Name}
                onClick={() => props.addNewRow(props.row)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { props.addNewRow(props.row); } }}
              >
                <img src={add_new} width={14} height={14} className="qualif-row-action-icon" alt="" />
                <span>{tr('qualificationInfo.addQualificationPrefix')} {props.row.Qualification_Name}</span>
              </div>
            )}
            {props.row.Id > 10000 && (
              <div
                className="removeadded-row qualif-row-action qualif-row-action--remove"
                data-name={"Remove " + props.row.Qualification_Name}
                onClick={() => props.removeRow(props.row)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { props.removeRow(props.row); } }}
              >
                <img src={remove} width={14} height={14} className="qualif-row-action-icon" alt="" />
                <span><Text k="qualificationInfo.removeLabel" /></span>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Phase C.7.4D-R6.3 (§4 make post-specific requirements visible): reads the same
          PostConfiguration "Qualification Percentage"/"Qualification Grade" rows the parent already
          fetches for client-side validation (isValid()) — purely presentational, no new API call, no
          new business rule, and the values are dynamic per post (never hard-coded). Renders nothing
          when this qualification has no configured percentage/grade rule for the candidate's post. */}
      {(() => {
        // A configured `Value` of 0 behaves as "no threshold" in the existing isValid() percentage
        // check too (percentageValue > entered only ever fails for a negative entry) — so it's treated
        // the same way here, rather than showing a literal, misleading "Minimum percentage: 0%".
        const pctRule = (props.percentageData || []).find((p) => p.RefId1 === props.row.Id && p.Value > 0);
        const gradeRule = (props.gradeData || []).find((g) => g.RefId1 === props.row.Id && g.ValueStr);
        if (!pctRule && !gradeRule) return null;
        return (
          <div className="row">
            <div className="col-12">
              <div className="qualif-requirement-hint">
                <span className="qualif-requirement-hint-label"><Text k="qualificationInfo.requirementLabel" />:</span>{" "}
                {pctRule && (
                  <span>
                    <Text k="qualificationInfo.minimumPercentageLabel" /> {pctRule.Value}%
                  </span>
                )}
                {pctRule && gradeRule && <span className="qualif-requirement-sep"> &bull; </span>}
                {gradeRule && (
                  <span>
                    <Text k="qualificationInfo.acceptedGradesLabel" />: {gradeRule.ValueStr}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })()}
      {/* <button onClick={() => console.log(candidateData)} /> */}
    </>
  );
};

export default QualificationRow_new;